import { useEffect, useRef } from "react";

const BARS = 48;

export const LiveWaveform = ({ active }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!active) return;
    let stream, ctx, raf;
    let cancelled = false;
    (async () => {
      try {
        stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        if (cancelled) return stream.getTracks().forEach((t) => t.stop());
        ctx = new (window.AudioContext || window.webkitAudioContext)();
        const analyser = ctx.createAnalyser();
        analyser.fftSize = 256;
        ctx.createMediaStreamSource(stream).connect(analyser);
        const data = new Uint8Array(analyser.frequencyBinCount);
        const draw = () => {
          const c = canvasRef.current;
          if (!c) return;
          const g = c.getContext("2d");
          analyser.getByteFrequencyData(data);
          g.clearRect(0, 0, c.width, c.height);
          const w = c.width / BARS;
          for (let i = 0; i < BARS; i++) {
            const v = data[Math.floor((i / BARS) * data.length * 0.7)] / 255;
            const h = Math.max(3, v * c.height);
            g.fillStyle = i % 2 ? "#22C55E" : "#3B82F6";
            g.fillRect(i * w + 1, (c.height - h) / 2, w - 3, h);
          }
          raf = requestAnimationFrame(draw);
        };
        draw();
      } catch {
        /* mic permission denied: speech recognition still reports its own error */
      }
    })();
    return () => {
      cancelled = true;
      cancelAnimationFrame(raf);
      stream?.getTracks().forEach((t) => t.stop());
      ctx?.close();
    };
  }, [active]);

  if (!active) return null;
  return (
    <div data-testid="live-waveform" className="mt-3 rounded-lg bg-[#0F1117]/70 border border-[#22C55E]/30 px-3 py-2 fade-up">
      <canvas ref={canvasRef} width={600} height={48} className="w-full h-12" />
    </div>
  );
};
